const globalNavMenu = document.querySelector('.menu-icon');
const globalNavCloseMenu = document.querySelector('.menu-close-icon');

globalNavMenu.addEventListener('click', function (e) {
  document.body.classList.add('menu-open');
});

globalNavCloseMenu.addEventListener('click', function (e) {
  document.body.classList.remove('menu-open');
});
